import { createApp } from 'vue'
import App from './App.vue'
import '../src/style.css'

createApp(App).mount('#app')
